import React, {Component} from 'react';
import {connect} from 'react-redux'
import {Box} from 'reactjs-admin-lte'
import {Row,Col,FormGroup,ControlLabel,Button,ButtonToolbar,Modal,FormControl,Tabs,Tab,OverlayTrigger,Tooltip} from 'react-bootstrap'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import {Switch,Route,withRouter} from 'react-router-dom'
import Select from 'react-select'
import FontAwesome from 'react-fontawesome'
import WorkdocStore from 'stores/WorkdocStore'
import AutopartStore from 'stores/AutopartStore'
import ServicePlanStore from 'stores/ServicePlanStore'
import _ from 'lodash'
import RowItem from './RowItem'
import InputNumber from 'rc-input-number'
import './SSP.css'
import $ from 'jquery'
var NotificationSystem = require('react-notification-system');
class CarBrandValue extends Component {
  render () {
    return (
			<div className="Select-value" >
				<span className="Select-value-label">
          <span><img alt='' src={'https://demo2.bigfix.co/korat/img/car_brand/'+this.props.value.label+'-32x32.png'}/> </span>   
					{this.props.children}
				</span>
			</div>
		);
	}
}

class ScheduledServicePlan extends Component {

  constructor(...args){
    super(...args)
    this.state = {
      loading:false,
      carBrandSel:null,
      brand:[],
      carModelSel:null,
      model:[],
      carSeriesSel:null,
      series:[],
      car_brand:null,
      car_model:null,
      car_series:null,
      showResult:false,
      data:{config:[],liquid:[],part:[],wage:[],other:''},
      showConfig:false,
      config:[],
      configValid:[],
      carCatIdSel:0,
      initBrandSel:this.props.brandSel,initModelSel:this.props.modelSel,initSeriesSel:this.props.seriesSel,mileageSel:this.props.mileageSel,
      options:[],
      can_drag:false,
      darg_id:null
    }
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    if(this.props.workNo!==''){
      this.setState({loading:true})
      WorkdocStore.loadWorkdocCarInfo(this.props.workNo,(result)=>{
        this.setState({loading:false,initBrandSel:result.data.brand_id,initModelSel:result.data.model_id,initSeriesSel:result.data.series_id,mileageSel:result.data.mileage},()=>{
          this.loadBrandOptions()
        })
      },
      (error)=>{
        this.setState({loading:false})
      })
    }else{
      this.loadBrandOptions()
    }

    $('body').on('click', ()=> { 
      $('.table-responsive').css( "overflow-x", "auto" );
    });
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getNumberCommas(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  }

  getMileageSelClass(mileage,config,index){
    const {mileageSel} = this.state
    let nextMileage = 9999999
    let preMileage = 0
    if(index+1<config.length){
      nextMileage = (config[index+1].mileage*1 + mileage*1)/2      
    }
    if(index-1>=0){
      preMileage = (config[index-1].mileage*1 + mileage*1)/2      
    }
    //console.log('c',mileageSel,mileage,preMileage,nextMileage)
    if(mileage*1 <= mileageSel*1 && mileageSel*1 <=nextMileage){
      return 'bg-green'
    }else if(mileage*1 >= mileageSel*1 && mileageSel*1 >=preMileage){
      return 'bg-green'
    }else{
      return ''
    }
  }

  getRecurringAmount(data,field,index){
    if(data[field][index]['recurring_mileage']>0){
      let row = data[field][index]
      //console.log('row',row)

      data['config'].map((item,dindex)=>{
        let key = 'm_'+item['mileage']          
        if(key in row){
          //console.log('loop',key)
          if((item['mileage']*1)%(row['recurring_mileage']*1)===0){
            data[field][index][key]['amount'] = row['amount']; 
          }else{
            data[field][index][key]['amount'] = 0;
          }
        }
        return item
      })
    }
    return data
  }

  newEmptyConfig(number) {
    return new Array(number).fill(null).map((item,index)=>{
      return {car_cat_id:'',config_id:'',duration:'',mileage:''}
    })
  }

  newEmptyRow(number,field) {
    let {data} = this.state
    let seq = data[field].length+1
    return new Array(number).fill(null).map((item,index)=>{
      return {added_by:'',added_date:'',amount:'',bf_service_plan_id:field+'genid'+seq,car_cat_id:'',recurring_mileage:'',cost_per_unit:'0',detail:'',discount_amount:'0',discount_percent:'0',item_type:field,itemnum:'',m_2000:{amount:'',volume:'',volume_unit:''},m_4000:{amount:'',volume:'',volume_unit:''},part_from:'',price_per_unit:'0',productcode:'',quantity:'',seq:seq.toString(),stock_flag:'',wage_itemnum:''}
    })
  }

  loadData(carCatIdSel='1'){
    this.props.history.push({pathname:'/ssp/'+carCatIdSel,search:'',state:{}})
    this.setState({loading:true})
    ServicePlanStore.loadSchedule(carCatIdSel,(result)=>{
      let data = result.data
      let config = JSON.parse(JSON.stringify(result.data.config))
      let configValid = config.map((item,index)=>{
        return {duration:false,mileage:false}
      })
      data.liquid = data.liquid.map((item,index)=>{
        item.seq = (index+1).toString()
        return item
      })
      data.part = data.part.map((item,index)=>{
        item.seq = (index+1).toString()
        return item
      })
      data.wage = data.wage.map((item,index)=>{
        item.seq = (index+1).toString()
        return item
      })
      this.setState({loading:false,data:data,config:config,configValid:configValid})
    })
  }
  

  loadBrandOptions(){
    let {initBrandSel} = this.state
    WorkdocStore.loadCarCategory(0,(result)=>{
      let carBrandSel = null
      let options = result.data.map((item,index)=>{
        
        let brand = { value: item.cat_id, label: item.name }
        if(initBrandSel==item.cat_id){
          carBrandSel = brand;
        }
        return brand
      })
      this.setState({brand:options})
      if(carBrandSel!==null){
        this.onCarBrandChange(carBrandSel)
      }
    })
  }

  onCarBrandChange(value){
    if (value!==null&&value!==undefined) {
      let carModelSel = null
      let {initModelSel} = this.state
      this.setState({carBrandSel:value,car_brand:value.label})
      
      if(value!==null && value!==undefined){
        WorkdocStore.loadCarCategory(value.value,(result)=>{
          let options = result.data.map((item,index)=>{
            let model = { value: item.cat_id, label: item.name }
            if(initModelSel==item.cat_id){
              carModelSel = model;
            }
            return model;
          })
          this.setState({model:options,series:[],carModelSel:null,carSeriesSel:null,car_model:null,car_series:null,initBrandSel:''})
          if(carModelSel!==null){
            this.onCarModelChange(carModelSel)
          }
        })
      }else{
        this.setState({car_brand:null,car_model:null,car_series:null,carBrandSel:null,carModelSel:null,carSeriesSel:null,model:[],series:[],showResult:false})
      }
    } else {
      this.setState({car_brand:null,car_model:null,car_series:null,carBrandSel:null,carModelSel:null,carSeriesSel:null,model:[],series:[],showResult:false})
    }
  }

  onCarModelChange(value){
    let {initSeriesSel} = this.state
    if (value!==null&&value!==undefined) {
      this.setState({carModelSel:value,showResult:true,carCatIdSel:value.value,car_model:value.label})            
      let carSeriesSel = null
      WorkdocStore.loadCarCategory(value.value,(result)=>{
        let options = result.data.map((item,index)=>{
          let series = { value: item.cat_id, label: item.name }
          if(initSeriesSel===item.cat_id){
            carSeriesSel = series
          }
          return series
        })
        this.setState({series:options,carSeriesSel:null,car_series:null,initBrandSel:'',initModelSel:'',initSeriesSel:''})  
        if(carSeriesSel!==null){
          this.setState({carCatIdSel:carSeriesSel.value})
          this.loadData(carSeriesSel.value)
        }else{
          this.loadData(value.value)
        }        
      })
    } else {
      this.setState({car_model:null,car_series:null,series:[],carModelSel:null,carSeriesSel:null,showResult:false})
    }
  }

  onCarSeriesChange(value){
    if (value!==null&&value!==undefined) {
      this.setState({carSeriesSel:value,showResult:true,car_series:value.label})
    } else {
      this.setState({carSeriesSel:null,showResult:false,car_series:null})
    }
  }

  onRowAdd(number,field) {
    let {data} = this.state
    data[field] = data[field].concat(this.newEmptyRow(number,field))
    this.setState({data:data})
  }

  onConfigRowAdd(number) {
    let {config,configValid} = this.state
    config = config.concat(this.newEmptyConfig(number))
    configValid.push({duration:false,mileage:false})
    this.setState({config:config,configValid:configValid})
  }

  onMoveRow(field,id,afterId) {
    let {data} = this.state
    var rows = _.clone(data[field]);
    var currentRow = _.filter(rows, function (r) { return r.item_type+r.seq === id;})[0];
    var afterRow = _.filter(rows, function (r) { return r.item_type+r.seq === afterId;})[0];

    var currentRowIndex = rows.indexOf(currentRow);
    var afterRowIndex = rows.indexOf(afterRow);

    // remove the current row
    rows.splice(currentRowIndex, 1);
    // put it after
    rows.splice(afterRowIndex, 0, currentRow);

    data[field] = rows
    this.setState({data: data});
  }

  onConfigChange(index,field,e) {
    let {config} = this.state
    config[index][field] = e
    this.setState({config:config})
  }

  onConfigSaveClick() {
    let {data,config,configValid} = this.state
    let success = true
    configValid = config.map((item,index)=>{
      return {duration:false,mileage:false}
    })
    this.setState({configValid:configValid})
    config.forEach((item,index)=>{
      if (item.duration==='') {
        success = false
        configValid[index].duration = true
      }  
      if (item.mileage==='') {
        success = false
        configValid[index].mileage = true
      }  
    })
    this.setState({configValid:configValid})
    
    if (success) {
      data.config = JSON.parse(JSON.stringify(config))
      data.config.forEach((items,indexs)=>{  
        data.liquid.forEach((item,index)=>{
          let key = 'm_'+items.mileage
          if (typeof item[key]==='undefined') {
            item[key] = {amount:'',volume:'',volume_unit:''}
          }
        })
        data.part.forEach((item,index)=>{
          let key = 'm_'+items.mileage
          if (typeof item[key]==='undefined') {
            item[key] = {amount:'',volume:'',volume_unit:''}
          }
        })
        data.wage.forEach((item,index)=>{
          let key = 'm_'+items.mileage
          if (typeof item[key]==='undefined') {
            item[key] = {amount:'',volume:'',volume_unit:''}
          }
        })
      })
      this.setState({data:data,showConfig:false})
    }  
  }

  onRowNumberChange(index,field,key,e) {
    let {data} = this.state
    data[field][index][key].amount = e
    this.setState({data:data})
  }

  onColDetailChange(field,index,key,e) {
    let {data} = this.state
    data[field][index][key] = key==='detail'?e.target.value:e

    if(key==='price_per_unit'||key==='quantity'){
      let quantity = data[field][index]['quantity']
      let price_per_unit = data[field][index]['price_per_unit']
      quantity = (quantity===''||quantity===null||quantity===undefined||isNaN(quantity)?0:quantity)
      price_per_unit = (price_per_unit===''||price_per_unit===null||price_per_unit===undefined||isNaN(price_per_unit)?0:price_per_unit)
      data[field][index]['amount'] = quantity*price_per_unit
      data = this.getRecurringAmount(data,field,index)
    }else if(key==='recurring_mileage'){
      data = this.getRecurringAmount(data,field,index)
    }
    this.setState({data:data})
  }

  onConfigDel(index) {
    let {data,config,configValid} = this.state
    config.splice(index,1)
    configValid.splice(index,1)
    data.config = JSON.parse(JSON.stringify(config))
    this.setState({data:data,config:config,configValid:configValid}) 
  }

  onSaveClick() {
    let {data,carCatIdSel} = this.state
    let {messages} = this.props
    ServicePlanStore.saveSchedule(carCatIdSel,data,(result)=>{
      if (result.status==='OK') {
        this.setState({data:result.data})
        this._notificationSystem.addNotification({
          title: messages['Notification'],
          message: messages['Save Successfully'],
          level: 'info',
          position: 'tc'
        });
      }
    },()=>{
      this._notificationSystem.addNotification({
        title: messages['Notification'],
        message: messages['Error Please Try Again'],
        level: 'error',
        position: 'tc'
      });
    })
  }

  onTabsSelect(key) {
    this.setState({carCatIdSel:key})    
    this.loadData(key)
  }

  onMileageSel(mileage){
    let {data} = this.state
    this.setState({mileageSel:mileage})
    let newData = JSON.parse(JSON.stringify(data))
    newData.part = newData.part.reduce((rresult,item,index)=>{
      if('m_'+mileage in item){
        if(item['m_'+mileage]['amount']>0){
          rresult.push(item)
        } 
      }
      return rresult
    },[])
    newData.liquid = newData.liquid.reduce((rresult,item,index)=>{
      if('m_'+mileage in item){
        if(item['m_'+mileage]['amount']>0){
          rresult.push(item)
        } 
      }
      return rresult
    },[])
    newData.wage = newData.wage.reduce((rresult,item,index)=>{
      if('m_'+mileage in item){
        if(item['m_'+mileage]['amount']>0){
          item['amount'] = item['m_'+mileage]['amount']
          item['quantity'] = 1;
          item['price_per_unit'] = item['m_'+mileage]['amount']
          rresult.push(item)
        } 
      }
      return rresult
    },[])
    this.props.onSelect(newData)
  }

  onSearch(index,field,query){
    let {data} = this.state
    let that = this
    if (field==='wage') {
      AutopartStore.loadWageItemList(-1,query,function(result){
        let options = result.data.map((item,index)=>{
          return {
            category_id:item.category_id,
            category_name:item.category_name,
            description:item.description,
            itemcode:item.itemcode,
            itemcode_og:item.itemcode_og,
            price:item.price,
            servicecode:item.servicecode,
          }
        })
        that.setState({options:options})
      })
    } else if (field==='part') {
      AutopartStore.loadStockPartItemList(-1,query,function(result){
        let options = result.data.map((item,index)=>{
          return {
            category_id:item.cat_id,
            category_name:item.cat_name,
            description:item.description,
            itemcode:item.itemnum,
            price:item.price_per_unit,
            quantity:item.quantity,
          }
        })
        that.setState({options:options})
      })
    }  
    data[field][index]['detail'] = query
    this.setState({data:data})
  }

  onTypeaheadChange(index,field,option) {
    let {data} = this.state
    if (option.length===1) {
      data[field][index].detail = option[0].description
      if (typeof option[0].itemcode!=='undefined'){
        data[field][index].itemnum = option[0].itemcode
        data[field][index].amount = option[0].price
        data[field][index].price_per_unit = option[0].price
        data[field][index].quantity = 1
      } else {
        if (data[field][index].quantity==='')
          data[field][index].quantity = 1
      }
    }
    this.setState({data:data})
  }

  renderBrandOption(option){
    return (
      <span><img alt='' src={'https://demo2.bigfix.co/korat/img/car_brand/'+option.label+'-32x32.png'}/> {option.label}</span>     
    )
  }

  renderSearch(){
    let {carBrandSel,brand,carModelSel,model} = this.state
    let {messages} = this.props
    return (
      <Row>
        <Col md={6}>
          <FormGroup>
            <ControlLabel>{messages['Brand']}</ControlLabel>
            <Select   
              className='select-plus'         
              placeholder={messages['Select Brand']}
              value={carBrandSel}
              valueComponent={CarBrandValue}
              onChange={this.onCarBrandChange.bind(this)}
              options={brand}
              optionRenderer={this.renderBrandOption.bind(this)}
            />     
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <ControlLabel>{messages['Model']}</ControlLabel>
            <br />
            <Select   
              className='select-plus'         
              placeholder={messages['Select Model']}
              value={carModelSel}
              onChange={this.onCarModelChange.bind(this)}
              options={model}                   
            /> 
          </FormGroup>
        </Col>
        {/* <Col md={4} style={{display:'none'}}>
          <FormGroup>
            <ControlLabel>โฉมรถยนต์(แบบ)</ControlLabel>
            <Select   
              className='select-plus'         
              placeholder={'เลือกแบบ'}
              value={carSeriesSel}
              onChange={this.onCarSeriesChange.bind(this)}
              options={series}              
            /> 
          </FormGroup>
        </Col> */}
      </Row>
    )
  }

  renderEmptyHeadTable() {
    let {config} = this.state.data
    let arr = []
    let noOfColumn = 10
    if (config.length<noOfColumn)
      arr = this.newEmptyConfig(noOfColumn-config.length)
    if (arr.length<=noOfColumn) {
      return(
        arr.map((item,index)=>{
          return(<th key={index} style={{width:'100px'}} className='text-center'>-<br /></th>)
        })
      )  
    } 
    return  
  }

  renderHeadTable() {
    let {config} = this.state.data
    let {messages} = this.props
    return(
          <thead key='head-table'>
            <tr>
              <th style={{width:'300px'}} colSpan={2} rowSpan={3} className='text-left'>{messages['Item Name']}</th>
              <th style={{width:'100px'}} rowSpan={3} className='text-center'>{messages['Change Every']}<br />({messages['Km']})</th>
              <th style={{width:'100px'}} rowSpan={3} className='text-center'>{messages['Quantity']}</th>
              <th style={{width:'100px'}} rowSpan={3} className='text-center'>{messages['Price']}<br />{messages['Unit']}<br />({messages['Bath']})</th>
              <th style={{width:'100px'}} rowSpan={3} className='text-center'>{messages['Total Price']}<br />({messages['Bath']})</th>
              <th colSpan={config.length<10?15:5+config.length} className='text-center'>{messages['Distance']} <Button onClick={()=>{this.setState({showConfig:true})}} bsSize='xs' bsStyle='default'><FontAwesome name='road' /> {messages['Increase Distance']}</Button></th>
            </tr>
            <tr>
              {config.map((item,index)=>{
                return(
                  <th key={index} style={{width:'100px'}} 
                  className={'text-center '+this.getMileageSelClass(item.mileage,config,index) }
                  onClick={this.onMileageSel.bind(this,item.mileage)}
                  >{item.mileage>0?this.getNumberCommas(item.mileage):<br />}</th>
                )
              })}
              {this.renderEmptyHeadTable()}
            </tr>
            <tr>
              {config.map((item,index)=>{
                return(
                  <th key={index} style={{width:'100px'}} 
                  className={'text-center '+this.getMileageSelClass(item.mileage,config,index) }
                  onClick={this.onMileageSel.bind(this,item.mileage)}
                  >{item.duration!==''?item.duration+' '+messages['Month']:<br />}</th>
                )
              })}
              {this.renderEmptyHeadTable()}
            </tr>
          </thead>
    )
  }

  renderTotalSummary(field) {
    let {data} = this.state
    let _config = JSON.parse(JSON.stringify(data.config))
    if (_config.length<10)
      _config = _config.concat(this.newEmptyConfig(10-_config.length))
    return(
      _config.map((items,indexs)=>{
        let key = 'm_'+items.mileage
        let liquid = 0
        let part = 0
        let wage = 0
        let sum = 0
        data['liquid'].forEach((item,index)=>{
          if (typeof item[key]!=='undefined')
            liquid += item[key].amount*1
        })
        data['part'].forEach((item,index)=>{
          if (typeof item[key]!=='undefined')
            part += item[key].amount*1
        })
        data['wage'].forEach((item,index)=>{
          if (typeof item[key]!=='undefined')
            wage += item[key].amount*1
        })
        sum = (liquid+part+wage)
        return(
          <th key={indexs} className='text-center'>{sum>0?this.getNumberFormat(sum):''}</th>
        )
      })
    )
  }

  renderSummary(field) {
    let {data} = this.state
    let _config = JSON.parse(JSON.stringify(data.config))
    if (_config.length<10)
      _config = _config.concat(this.newEmptyConfig(10-_config.length))
    return(
      _config.map((items,indexs)=>{
        let key = 'm_'+items.mileage
        let val = 0
        data[field].forEach((item,index)=>{
          if (typeof item[key]!=='undefined')
            val += item[key].amount*1
        })
        return(
          <th key={indexs} className='text-center'>{val>0?this.getNumberFormat(val):''}</th>
        )
      })
    )
  }

  renderColConfig(field,indexs,items) {
    let {data} = this.state
    let _config = JSON.parse(JSON.stringify(data.config))
    if (_config.length<10)
      _config = _config.concat(this.newEmptyConfig(10-_config.length))
    return(
      _config.map((item,index)=>{
        let key = 'm_'+item.mileage
        let val = ''
        if (typeof items[key]!=='undefined') {
          val = items[key].amount
          return(
            <td key={index} className={'text-center '+this.getMileageSelClass(item.mileage,data.config,index)}>
              <InputNumber
                className='text-center input-number-format-form-control'
                value={val} 
                onChange={this.onRowNumberChange.bind(this,indexs,field,key)}
                formatter={value =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                }
              />
            </td>
          )
        } else {
          return(<td key={index} className='text-center'></td>)
        } 
      })
    )
  }

  _renderMenuItemChildren(option, props, index) {
    let {messages} = this.props
    if(option.price>0){

      $('.table-responsive').css( "overflow-x", "initial" );
      
      return (
        <div key={option.itemcode}>               
          <span>{option.description} - {option.price} {messages['Bath']}</span>
        </div>
      );
    }else{
      return (
        <div key={option.itemcode}>               
          <span>{option.description}</span>
        </div>
      );
    }
  }

  renderColDetail(field,indexs) {
    let {messages} = this.props
    let {data,options,can_drag,darg_id} = this.state
    let uniq = field+data[field][indexs].bf_service_plan_id
    let hover = (
      <OverlayTrigger
          key={'right'}
          placement={'right'}
          overlay={
              <Tooltip id={'tooltip-right'}>
                Hold & darg to sort the Items
              </Tooltip>
          }
          >
          <div className='wrap-tool'>
            <div className='card-tool'><FontAwesome name='bars' /></div>
          </div>
      </OverlayTrigger>
    )
    if (field==='wage') {
      return ([
        <td 
          key={0} 
          className='text-center' 
          style={{verticalAlign:'middle',width:'50px',minWidth:'50px'}}
          onMouseEnter={()=>{this.setState({can_drag:true,darg_id:uniq})}} 
          onMouseLeave={()=>{this.setState({can_drag:false,darg_id:null})}}
        >
          {can_drag&&darg_id===uniq?hover:indexs+1}
        </td>,        
        <td key={1} colSpan={5} className='text-left'>
          <AsyncTypeahead
                    allowNew={true}
                    multiple={false}
                    newSelectionPrefix={messages['Add New Item']+' : '}
                    promptText={messages['Key For Search']+'...'}           
                    searchText={messages['Searching']+'...'}
                    selected={[{description:data[field][indexs].detail}]}
                    options={options}
                    labelKey="description"
                    onSearch={this.onSearch.bind(this,indexs,'wage')}
                    onChange={this.onTypeaheadChange.bind(this,indexs,'wage')}
                    placeholder=""
                    renderMenuItemChildren={this._renderMenuItemChildren.bind(this)}
                  />
        </td>
      ])
    }
    let key=0
    return([
      <td 
        key={++key} 
        className='text-center' 
        style={{verticalAlign:'middle',width:'50px',minWidth:'50px'}}
        onMouseEnter={()=>{this.setState({can_drag:true,darg_id:uniq})}} 
        onMouseLeave={()=>{this.setState({can_drag:false,darg_id:null})}}
      >
        {can_drag&&darg_id===uniq?hover:indexs+1}
      </td>,
      <td key={++key} className='text-left'>
        {field==='part'?
        <AsyncTypeahead
          allowNew={true}
          multiple={false}
          newSelectionPrefix={messages['Add New Item']+' : '}
          promptText={messages['Key For Search']+'...'}           
          searchText={messages['Searching']+'...'}
          selected={[{description:data[field][indexs].detail}]}
          options={options}
          labelKey="description"
          onSearch={this.onSearch.bind(this,indexs,'part')}
          onChange={this.onTypeaheadChange.bind(this,indexs,'part')}
          placeholder=""
          renderMenuItemChildren={this._renderMenuItemChildren.bind(this)}
        />
        :<FormControl value={data[field][indexs].detail} onChange={this.onColDetailChange.bind(this,field,indexs,'detail')} />}
      </td>,
      <td key={++key} className='text-center'>
        <InputNumber
          className='text-center input-number-format-form-control'
          value={data[field][indexs].recurring_mileage}
          onChange={this.onColDetailChange.bind(this,field,indexs,'recurring_mileage')}
          formatter={value =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          }
        />
      </td>,
      <td key={++key} className='text-center'>
        <InputNumber
          className='text-center input-number-format-form-control'
          value={data[field][indexs].quantity}
          onChange={this.onColDetailChange.bind(this,field,indexs,'quantity')}
          formatter={value =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          }
        />
      </td>,
      <td key={++key} className='text-center'>
        <InputNumber
          className='text-center input-number-format-form-control'
          value={data[field][indexs].price_per_unit}
          onChange={this.onColDetailChange.bind(this,field,indexs,'price_per_unit')}
          formatter={value =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          }
        />
      </td>,
      <td key={++key} className='text-center'>
        <InputNumber
          className='text-center input-number-format-form-control'
          value={data[field][indexs].amount}
          onChange={this.onColDetailChange.bind(this,field,indexs,'amount')}
          formatter={value =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          }
        />
      </td>
    ])
  }

  renderLiquidRowData() {
    let {data,can_drag} = this.state
    let rows = data.liquid.map((item,index)=>{
      return <RowItem 
        key={index} 
        id={item.item_type+item.seq} 
        item={item}
        targetField='liquid'
        can_drag={can_drag}
        moveRow={this.onMoveRow.bind(this,'liquid')} 
        renderColConfig={this.renderColConfig.bind(this,'liquid',index)}
        renderColDetail={this.renderColDetail.bind(this,'liquid',index)}
      />
    })
    return rows
  }

  renderLiquidTable() {
    let {config} = this.state.data
    let {messages} = this.props
    return([
          <thead key='liquid-head'>
            <tr>
              <th colSpan={config.length<10?16:6+config.length} className='bg-silver text-left'>
                <FontAwesome name='circle' /> {messages['Chemical']}
              </th>
            </tr>
          </thead>,
          <tbody key='liquid-body'>
            {this.renderLiquidRowData()}
          </tbody>,
          <thead key='liquid-foot'>
            <tr>
              <th colSpan={6} className='text-left'>
                {messages['Including Chemicals']}
              </th>
              {this.renderSummary('liquid')}
            </tr>  
          </thead>
    ])
  }

  renderPartRowData() {
    let {data,can_drag} = this.state
    let rows = data.part.map((item,index)=>{
      return <RowItem 
        key={index} 
        id={item.item_type+item.seq}
        item={item}
        targetField='part'
        can_drag={can_drag}
        moveRow={this.onMoveRow.bind(this,'part')} 
        renderColConfig={this.renderColConfig.bind(this,'part',index)}
        renderColDetail={this.renderColDetail.bind(this,'part',index)}
      />
    })
    return rows
  }

  renderPartTable() {
    let {config} = this.state.data
    let {messages} = this.props
    return([
          <thead key='part-head'>
            <tr>
              <th colSpan={config.length<10?16:6+config.length} className='bg-silver text-left'>
                <FontAwesome name='circle' /> {messages['Part']}
              </th>
            </tr>
          </thead>,
          <tbody key='part-body'>  
            {this.renderPartRowData()}
          </tbody>,
          <thead key='part-foot'>
            <tr>
              <th colSpan={6} className='text-left'>
                {messages['Including Parts']}
              </th>
              {this.renderSummary('part')}
            </tr>  
          </thead>
    ])
  }

  renderWageRowData() {
    let {data,can_drag} = this.state
    let rows = data.wage.map((item,index)=>{
      return <RowItem 
        key={index} 
        id={item.item_type+item.seq}
        item={item}
        targetField='wage'
        can_drag={can_drag}
        moveRow={this.onMoveRow.bind(this,'wage')}
        renderColConfig={this.renderColConfig.bind(this,'wage',index)}
        renderColDetail={this.renderColDetail.bind(this,'wage',index)}
      />
    })
    return rows
  }

  renderWageTable() {
    let {config} = this.state.data
    let {messages} = this.props
    return([
          <thead key='wage-head'>
            <tr>
              <th colSpan={config.length<10?16:6+config.length} className='bg-silver text-left'>
                <FontAwesome name='circle' /> {messages['Wage']}
              </th>
            </tr>
          </thead>,
          <tbody key='wage-body'>  
            {this.renderWageRowData()}
          </tbody>,
          <thead key='wage-foot'>
            <tr>
              <th colSpan={6} className='text-left'>
                {messages['Including Wages']}
              </th>
              {this.renderSummary('wage')}
            </tr>
            <tr>
              <th colSpan={6} className='text-left'>
                {messages['Total Cost']} ({messages['Bath']})
              </th>
              {this.renderTotalSummary('wage')}
            </tr>  
          </thead>
    ])
  }

  renderResult(){
    let {car_brand,car_model} = this.state
    let car_detail = car_brand+'/'+car_model
    return (
      <div >
        <h4 className='text-center'>{car_detail}</h4>
        <div className='table-responsive'>
          <table className='table table-ssp table-bordered-solid' style={{minWidth:'1800px',marginBottom:'0'}}>
            {this.renderHeadTable()}
            {this.renderLiquidTable()}
            {this.renderPartTable()}
            {this.renderWageTable()}
          </table>
        </div>
        {this.renderNewItemButton()}
      </div>
    )
  }

  renderTabResult12(){
    let {showResult,series}  = this.state
    let {messages} = this.props
    return (
      <div style={{display:(showResult)?'':'none'}}>
      <Tabs defaultActiveKey={0} id="uncontrolled-tab-example">
        <Tab eventKey={0} title={messages['Model Not Specified']}>
          {this.renderResult()}
        </Tab>
        {
          series.map((item,index)=>(
            <Tab eventKey={index+1} title={item.label}>
              {this.renderResult()}
            </Tab>            
          ))
        }
      </Tabs>
      </div>
    )
  }

  renderTabResult(){
    let {showResult,series,carCatIdSel,carModelSel}  = this.state
    if(!showResult){
      return (<div/>)
    }
    return (
      <div style={{display:(showResult)?'':'none'}}>
      <Tabs 
          // defaultActiveKey={'info'} 
          activeKey={carCatIdSel}
          id='ssp-result-tabs'
          onSelect={this.onTabsSelect.bind(this)}
      >
          <Switch>
              <Route exact path={"/ssp/"+carModelSel.value} render={(props) => this.renderResult()}/>           
              {
                series.map((item,index)=>(
                  <Route key={index+1} exact path={"/ssp/"+item.value} render={(props) => this.renderResult()}/>                                                         
                ))
              }              
          </Switch>
          <Tab eventKey={carModelSel.value} title="ไม่ระบุรุ่น">            
          </Tab>
          {
            series.map((item,index)=>(
              <Tab key={index+1} eventKey={item.value} title={item.label}>
                
              </Tab>            
            ))
          }
      </Tabs>
      </div>
    )
  }

  renderNewItemButton() {
    let {messages} = this.props
    return (
      <Row style={{marginTop:'10px'}}>
        <Col md={12}>
          <div className='new-item-btn' style={{display:'inline-flex'}}>
            <Button className='bg-olive' onClick={this.onRowAdd.bind(this,1,'liquid')}><FontAwesome name='plus'/>&nbsp;{messages['Add Chemical Items']}</Button>&nbsp;
            <Button className='bg-olive' onClick={this.onRowAdd.bind(this,1,'part')}><FontAwesome name='plus'/>&nbsp;{messages['Add Part Items']}</Button>&nbsp;
            <Button className='bg-olive' onClick={this.onRowAdd.bind(this,1,'wage')}><FontAwesome name='plus'/>&nbsp;{messages['Add Wage Items']}</Button>
          </div>        
        </Col>
      </Row>
    )
  }

  renderConfigRowData() {
    let {config,configValid} = this.state
    let {messages} = this.props
    if (config.length===0) {
      return(<tr><td colSpan={3}>{messages['No Data']}</td></tr>)
    } else {
      return(
        config.map((item,index)=>{
          return(
            <tr key={index}>
              <td>
                  <InputNumber
                    className={'text-center input-number-format-form-control'+(configValid[index].mileage?' has-error':'')}
                    value={item.mileage}
                    onChange={this.onConfigChange.bind(this,index,'mileage')}
                    formatter={value =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    }
                  />
              </td>
              <td>
                  <InputNumber
                    className={'text-center input-number-format-form-control'+(configValid[index].duration?' has-error':'')}
                    value={item.duration}
                    onChange={this.onConfigChange.bind(this,index,'duration')}
                    formatter={value =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    }
                  />
              </td>
              <td className='text-center'>
                <Button bsStyle='danger' onClick={this.onConfigDel.bind(this,index)}><FontAwesome name='trash' /></Button>
              </td>
            </tr>
          )
        })
      )
    }
  }

  renderConfigTable() {
    let {messages} = this.props
    return(
      <div className='table-responsive'>
        <table className='table table-ssp table-bordered-solid' style={{marginBottom:'0'}}>
          <thead>
            <tr>
              <th style={{width:'200px'}} className='text-center'>{messages['Distance Km']}</th>
              <th style={{width:'200px'}} className='text-center'>{messages['Schedule']} ({messages['Month']})</th>
              <th style={{width:'50px'}} className='text-center'>{messages['Delete']} ?</th>
            </tr>
          </thead>
          <tbody>
            {this.renderConfigRowData()}
          </tbody>
        </table>
      </div>
    )
  }

  renderConfigModal() {
    let {showConfig} = this.state
    let {messages} = this.props
    return(
        <Modal show={showConfig} enforceFocus={false} onHide={()=>{this.setState({showConfig:false})}} dialogClassName="modal-md">
          <Modal.Header closeButton>
            <Modal.Title>Config</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.renderConfigTable()}
            <Row style={{marginTop:'10px'}}>
              <Col md={12}>
                <div className='new-item-btn' style={{display:'inline-flex'}}>
                  <Button className='bg-olive' onClick={this.onConfigRowAdd.bind(this,1)}><FontAwesome name='plus'/>&nbsp;{messages['Add Item']}</Button>
                </div>        
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <ButtonToolbar className='pull-right'>
              <Button bsStyle='primary' onClick={this.onConfigSaveClick.bind(this)}><FontAwesome name='save' /> {messages['Save']}</Button>
              <Button bsStyle='default' onClick={()=>{this.setState({showConfig:false})}}><FontAwesome name='close' /> {messages['Close']}</Button>
            </ButtonToolbar>
          </Modal.Footer>
        </Modal>
    )
  }

  renderFooter(){
    let {showResult} = this.state
    let {messages} = this.props
    return (
      <div className='pull-right' style={{display:(showResult)?'':'none'}}>
        <Button bsStyle='primary' onClick={this.onSaveClick.bind(this)}><FontAwesome name='save'/> {messages['Save']}</Button>
      </div>
    )
  }


  
  render() {
    let {loading} = this.state
    let {messages} = this.props
    return (
      <div className='ssp'>
        <Box loading={loading}>
          <Box.Header border={true}>
            <Box.Title>
              {messages['Title']}
            </Box.Title>
          </Box.Header>
          <Box.Body>
            {this.renderSearch()}
            {this.renderTabResult()}            
            {this.renderFooter()}
          </Box.Body>
        </Box>    
        {this.renderConfigModal()}
        <NotificationSystem ref="notificationSystem" />
      </div>
    )
  }
}

ScheduledServicePlan.defaultProps = {
  brandSel:'',
  modelSel:'',
  seriesSel:'',
  mileageSel : 0 ,
  workNo:'',
  onSelect:()=>{}
}

const _Connect = connect(
  (state) => ({messages: state.message.view.ssp.ScheduledServicePlan}),null,null,{withRef:true}
)(ScheduledServicePlan);


export default withRouter(_Connect)




// WEBPACK FOOTER //
// ./src/view/ssp/ScheduledServicePlan.js